import { useContext } from 'react'

import type { CompareSelectionContextValue } from './CompareSelectionContext'
import { CompareSelectionContext } from './CompareSelectionContext'

/**
 * Null-safe read of the compare-selection context.
 *
 * Unlike {@link useCompareSelection}, this does NOT throw when no provider is
 * present — it returns `null`. `Card` renders on several surfaces (ALP grid,
 * plus the MoreFromSeller / RecentlyViewed / SimilarInventory carousels), and
 * the ones rendered outside `CompareSelectionProvider` get `null` → no overlay,
 * existing behavior unchanged.
 *
 * Note that a non-null return is not limited to the ALP grid: SimilarInventory
 * renders *inside* this provider (see ListingGridWithFilters), so its cards do
 * show the overlay. Any surface in that position must also be represented in
 * the provider's facade cache, or its selections cannot be resolved — see the
 * comment on `rawListings` in CompareSelectionProvider.
 */
export const useOptionalCompareSelection =
  (): CompareSelectionContextValue | null => useContext(CompareSelectionContext)
